var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import mime from 'mime-types';
import urls from "../../urls";
/**
 * If the parameter is both set, and is not null
 * @param toCheck
 * @returns {boolean}
 */
function isSet(toCheck) {
    return typeof toCheck !== 'undefined' && toCheck !== null;
}
/**
 * This encapsulates what Dropbox.serializers.FileSerializer returns, but with JS classes where needed.
 */
var FileObject = /** @class */ (function () {
    function FileObject(data_dict) {
        this.id = data_dict['id']; // id: 1,
        this.Organization = data_dict['Organization']; // Organization: 1,
        this.file = data_dict['file']; // file: 'url/path/to/file',
        this.fullName = data_dict['name'].trim(); // name: 'A custom file name',
        this.dateUploaded = data_dict['dateUploaded']; // dateUploaded: 2019-07-01T15:57:52.091904Z
        this.description = data_dict['description']; // description: 'Some information about the file',
        this.createdBy = data_dict['created_by']; // created_by: 'arthur' //May be null
        this.size = data_dict['size']; // size: 0, //In bytes
        var type = data_dict['type']; // type: 'text/csv',
        if (!isSet(type)) {
            type = mime.lookup(this.realFileName) || "unknown/unknown";
        }
        //Handle bad type information, or type too long for easy display
        if (type.lastIndexOf('/') === -1 || type.length > 20) {
            if (this.realFileName.lastIndexOf('.') === -1) {
                type = "unknown/unknown";
            }
            else {
                type = "extension/" + this.realFileName.substring(this.realFileName.lastIndexOf('.') + 1);
            }
        }
        this.type = type;
    }
    Object.defineProperty(FileObject.prototype, "humanSize", {
        /**
         * Converts a long string of bytes into a readable format e.g KB, MB, GB, TB, YB
         *
         * https://ourcodeworld.com/articles/read/713/converting-bytes-to-human-readable-values-kb-mb-gb-tb-pb-eb-zb-yb-with-javascript
         */
        get: function () {
            if (!this.size) {
                return 'Empty';
            }
            var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(this.size) / Math.log(1024));
            return String((this.size / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileObject.prototype, "isReport", {
        get: function () {
            return this.type === "application/pdf" && this.fullName.endsWith("__REPORT__");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileObject.prototype, "isDataset", {
        get: function () {
            return this.type === "text/csv" && this.fullName.endsWith("__DATA__");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileObject.prototype, "name", {
        /**
         * Trim off the end for something which is actually usable
         */
        get: function () {
            if (this.isReport) {
                return this.fullName.substring(0, this.fullName.length - "__REPORT__".length);
            }
            if (this.isDataset) {
                return this.fullName.substring(0, this.fullName.length - "__DATA__".length);
            }
            return this.fullName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileObject.prototype, "realFileName", {
        /**
         * The name of the file to be downloaded from the URL
         */
        get: function () {
            var parser = document.createElement('a');
            parser.href = this.file;
            return parser.pathname.substring(parser.pathname.lastIndexOf('/') + 1);
        },
        enumerable: false,
        configurable: true
    });
    return FileObject;
}());
export { FileObject };
export default {
    namespaced: true,
    state: {
        files: [],
        loaded: false,
    },
    mutations: {
        //This not only sets the files, but adds a new 'humanSize' property to them
        setFiles: function (state, payload) {
            //Make sure the required fields exist, and that the file has some data in it
            //The uploader has an artifact where zero size files are created before the upload is complete,
            // or if an upload crashed
            payload = payload.filter(function (file) {
                return isSet(file.Organization) &&
                    isSet(file.file) &&
                    isSet(file.id) &&
                    isSet(file.dateUploaded) &&
                    isSet(file.description) &&
                    isSet(file.name) &&
                    isSet(file.size) &&
                    file.size > 0;
            });
            state.files = [];
            for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                var file = payload_1[_i];
                state.files.push(new FileObject(file));
            }
            //TODO - provide option to sort by the columns 
            // for now just reverse the order to display latest uploaded files
            state.files.reverse();
            state.loaded = true;
        },
        clearFiles: function (state, payload) {
            state.files = [];
            state.loaded = false;
        },
    },
    actions: {
        //TODO:  Add support for retrieving info about a single file
        getFiles: function (context) {
            var _this = this;
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log("Retrieving Files List");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axios.get(urls.files)];
                        case 2:
                            response = _a.sent();
                            context.commit('setFiles', response.data);
                            resolve(null);
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.log(error_1);
                            reject();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        },
    },
    getters: {
        //Filter out "Reports" & "Datasets" so those can be displayed separately.
        goodFiles: function (state) {
            return state.files.filter(function (file) {
                return (!file.isReport && !file.isDataset);
            });
        },
        reports: function (state) {
            return state.files.filter(function (file) {
                return file.isReport;
            });
        },
        datasets: function (state) {
            return state.files.filter(function (file) {
                return file.isDataset;
            });
        },
        fileById: function (state) { return function (fileId) {
            return state.files.find(function (file) {
                return String(file.id) === String(fileId);
            });
        }; }
    }
};
